import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';

import BlogCategories from '../../../shared/components/blog-categories/BlogCategories';
import {withTranslation} from "react-i18next";

class Categories extends PureComponent {

  render() {
    const { blog, t } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
            
            <div className="card__title">
              <h5 className="bold-text">{t('settings.categories.title')}</h5>
            </div>

            <BlogCategories blog={blog} />

          </CardBody>
        </Card>
      </Col>
    );
  }
}
export default withTranslation('dashboard')(Categories);
